import { ADD_ITEM, DELETE_ITEM } from "./ActionTypes";

const addItem = (val) => {
  
  return {
    type: ADD_ITEM,
    payload:val
  };
};

const deleteItem = () => {
  return {
    type: DELETE_ITEM,
  };
};

export { addItem, deleteItem };